import { ApolloLink, Operation, FetchResult, Observable } from "@apollo/client";
import { print } from "graphql/language/printer";

export interface Options {
  /**
   * The global ruby resolve proc
   */
  resolveProc: (
    query: string,
    options: { variables: object; operation_name: string }
  ) => object;
}

export class RubyLink extends ApolloLink {
  private resolveProc: Options["resolveProc"];

  constructor({ resolveProc }: Options) {
    super();
    this.resolveProc = resolveProc;
  }

  public request(operation: Operation) {
    return new Observable<FetchResult>((observer) => {
      try {
        const data: any = this.execute(operation);
        const error = this.extractRubyError(data);

        if (!observer.closed) {
          if (error) {
            observer.error(error);
          } else {
            observer.next(data);
            observer.complete();
          }
        }
      } catch (error) {
        if (!observer.closed) {
          observer.error(error);
        }
      }
    });
  }

  private execute(operation: Operation) {
    const { query, variables, operationName } = operation;
    const vars = { variables, operation_name: operationName };
    return this.resolveProc(print(query), vars);
  }

  private extractRubyError(data: any) {
    if (data && data.isError) {
      const rubyError = data;
      const error = {
        message: rubyError.message,
        stack: rubyError.stack,
      };
      return error;
    }

    return false;
  }
}
